import { apiFetch } from "../utils/apiFetch";
import { API_BASE_OPERATOR as API_BASE } from "../config/vars";

export const fetchOperatorPolls = async () => {
    const response = await apiFetch(`${API_BASE}/polls/operator`);
    if (!response.ok) throw new Error("Сесія закінчилася. Увійдіть знову.");
    return await response.json();
};

export const createOperatorPoll = async ({ question, expires_at, location_id = null }) => {
    const response = await apiFetch(`${API_BASE}/polls/operator`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ question, expires_at, location_id }),
    });
    if (!response.ok) throw new Error("Не вдалося створити опитування");
    return await response.json();
};

export const fetchUnreadOperatorPolls = async () => {
    const response = await apiFetch(`${API_BASE}/polls/operator/unread`);
    if (!response.ok) throw new Error("Сесія закінчилася. Увійдіть знову.");
    return await response.json();
};

export const markOperatorPollsViewed = async () => {
    const response = await apiFetch(`${API_BASE}/polls/operator/mark-viewed/polls`, {
        method: "PUT",
    });
    if (!response.ok) throw new Error("Сесія закінчилася. Увійдіть знову.");
    return await response.json();
};

export const voteOperatorPoll = async (pollId, answer_yes) => {
    const id = parseInt(pollId);
    if (!Number.isFinite(id) || id <= 0) throw new Error("Некоректне опитування");

    const response = await apiFetch(`${API_BASE}/polls/operator/${id}/vote`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ answer_yes: Boolean(answer_yes) }),
    });

    let payload = null;
    try {
        payload = await response.json();
    } catch (_) {
        payload = null;
    }

    if (!response.ok) {
        const msg = payload?.detail || payload?.message || "Не вдалося проголосувати";
        throw new Error(msg);
    }
    return payload;
};
